import { PrivateRoutes } from './PrivateRoutes';
import { PublicRoutes } from './PublicRoutes';

export const AllRoutes = [...PrivateRoutes, ...PublicRoutes];
